export function debug(...args: unknown[]) {
  // eslint-disable-next-line no-console
  console.log(...args);
}
